export const en = {
  translation: {
    sign_out: "Sign Out",
    environment_header: "This is a {{environment}} environment",
    footer: "© {{year}} TailorMed. All rights reserved",
    main_title: "Export Data",
    select_all: "Select All",
    clear: "Clear",
    sub_title:
      "Export detailed financial and operational data for enrollments, claims, and free drug orders. To generate your report, pick the data type(s) (enrollments, claims, and/or orders), select filters such as date range, assignees, and facilities, then click ‘Export’ to download.",
    welcome: "Welcome",
    coming_soon: "Coming Soon!",
    login_email_support: "E-mail support",
    all_times: "All Times",
    this_week: "This Week",
    this_month: "This Month",
    all: "All",
    year_to_date: "Year to Date",
    last_12_month: "Last 12 Months",
    last_30_days: "Last 30 Days",
    current_quarter: "Current Quarter",
    show_columns: "Show Columns",
    hide_columns: "Hide Columns",
    loading_string: "Preparing your report. The download will start automatically once it’s ready.",
    error_fallback: {
      title: "Unexpected Error",
      ok_text: "Go Back",
      p1: "Uh oh! Something went wrong on our end.",
      p2: "Click the button below to go back to the previous page."
    },
    financial_insights: "Financial Insights",
    sidebar_menu: {
      sign_out: "Sign out",
      contact_support: "Contact Support"
    },
    cancel: "Cancel",
    send: "Send",
    contact_support: {
      please_provide_relevant_details_below: "Please provide the relevant details below",
      title: "Contact support",
      disclaimer: "Please do not input protected health information (e-PHI) in the subject",
      description: "Description *",
      subject: "Subject *",
      description_required: "Description is required",
      subject_required: "Subject is required",
      ticket_send_successfully: "Ticket was sent successfully",
      failed_to_send_ticket: "Failed to send message to support"
    },
    messages: {
      errors: {
        should_be_less_than: "{{fieldName}} should be less than {{maxCharacter}} character",
        pendo_tracking_error: "Error dispatching general report Pendo event"
      }
    },
    form_popups: {
      confirmed_close_title: "Unsaved Form Details",
      confirmed_close_content:
        "You have unsaved details in your form. Leaving the form will discard any unsaved changes."
    },
    are_you_sure_you_want_to_proceed: " Are you sure you want to proceed?",
    yes_sure: "Yes, I’m Sure",
    back: "Back",
    cant_show_data: "Can’t Show Data",
    sorry_something_went_wrong: "Sorry something went wrong. Please try to load the page.",
    filters: {
      date_type: "Date Type",
      date_range: "Date Range",
      facilities: "Facility",
      users: "Assignee",
      creation_date_type: "Creation Date",
      approved_date_type: "Approved Date",
      claim_date_type: "Claim Date",
      paid_date_type: "Paid Date",
      order_date_type: "Order Date",
      received_date_type: "Received Date",
      placeholder: {
        search_users: "Search assignees",
        search_facilities: "Search facilities"
      }
    },
    data_types: {
      export_report: "Export Report",
      export_report_note:
        "By exporting, you acknowledge that this file may contain PHI and is to be handled according to your organization's privacy policies.",
      title: "Data Type",
      sub_title: "Choose the data type(s) to include in your export.",
      enrollments_type: "Enrollments",
      enrollment_desc:
        "Export enrollment data, including patient details, program info, billing, funding, and key dates.",
      enrollment_filters_desc:
        "Filter by enrollment creation date for all enrollments or approved date for enrollments that are or were previously approved, enrollment assignee, and patient facility:",
      claims_per_enrollment_type: "Approved Copay Enrollments with Claims",
      claims_per_enrollment_desc:
        "Export approved copay enrollments with claims, including patient, program, and billing details.",
      claims_per_enrollment_filters_desc:
        "Filter by enrollment approved date, enrollment assignee, and patient facility:",
      claim_type: "Claims",
      claim_desc:
        "Export claim records, including claim statuses, submission dates, collected amounts, and remaining funds.",
      claims_filters_desc:
        "Filter by claim date for all claims or paid date for posted claims, claim assignee, and claim facility:",
      order_type: "Orders",
      order_desc:
        "Export order details, including product information, order statuses, tracking details, and cost savings.",
      order_filters_desc:
        "Filter by order date for all orders or received date for orders that have been received in pharmacy, pharmacy assignee, and pharmacy facility:",
      completed_order_type: "Completed Orders",
      completed_order_desc:
        "Export completed free and replacement medication orders, including product information, tracking details, and cost savings.",
      completed_order_filters_desc:
        "Filter by completion date (free drug = administration date, replacement = received date), pharmacy assignee, and pharmacy facility:"
    },
    columns: {
      description:
        "Choose the columns you'd like to include in your export. Some columns are required and cannot be deselected.",
      columns_selected: "{{selected}} of {{total}} Columns selected",
      clear_all: "Clear All",
      claim_breakdown: "All Claim Breakdown per Enrollment",
      line_items_breakdown: "Line Items Breakdown per Claim",
      order_breakdown: "All Orders",
      order_line_items_breakdown: "Line Items Breakdown per Order"
    }
  }
};
